import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Field} from '@app/interfaces';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {KpdCodeSelection} from '@app/shared/components/kpd-selector/kpd-selector.component';
import {KpdCodeApiService} from '@app/services/api/kpd-code-api.service';

@Component({
    selector: 'app-form-input-kpd-selector',
    templateUrl: './form-input-kpd-selector.component.html',
    styleUrls: ['./form-input-kpd-selector.component.scss'],
    standalone: false
})
export class FormInputKpdSelectorComponent implements OnInit, OnDestroy {
    @Input() control: FormControl;
    @Input() field: Field<string>;

    public kpdCode: string = '';
    public kpdName: string = '';

    private destroy$ = new Subject<void>();

    constructor(
        private cdr: ChangeDetectorRef,
        private kpdCodeApi: KpdCodeApiService
    ) {}

    ngOnInit() {
        // Load existing KPD code if present
        const existingCode = this.control.value;
        if (existingCode) {
            this.kpdCode = existingCode;
            // Fetch the name for display
            this.kpdCodeApi.getByCode(existingCode)
                .pipe(takeUntil(this.destroy$))
                .subscribe(
                    (kpdDetails) => {
                        this.kpdName = kpdDetails.name;
                        this.cdr.markForCheck();
                    },
                    (error) => {
                        console.error('Error fetching KPD code details:', error);
                    }
                );
        }

        // Listen to control status changes for validation feedback
        this.control.statusChanges
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.cdr.detectChanges();
            });
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    onKpdSelected(selection: KpdCodeSelection): void {
        this.kpdCode = selection.code;
        this.kpdName = selection.name;
        this.control.setValue(selection.code);
        this.control.markAsDirty();
    }

    onKpdCleared(): void {
        this.kpdCode = '';
        this.kpdName = '';
        this.control.setValue('');
        this.control.markAsDirty();
    }

    get label(): string {
        return this.field?.config?.label || $localize`:@@kpd-selector.label:KPD šifra`;
    }

    get placeholder(): string {
        return this.field?.config?.placeholder || $localize`:@@kpd-selector.placeholder:Išči po šifri ali nazivu...`;
    }

    get hint(): string {
        return this.field?.config?.description || $localize`:@@kpd-selector.hint:Klasifikacija proizvoda in storitev (KPD 2025)`;
    }
}
